import { Box } from "@mui/material";
import { useRef } from "react";

import { useOnScreen } from "utils/commonHooks";
import { MobileFilter } from "features/searchStore/components/MobileFilter";
import { FloatingFilter } from "features/searchStore/components/FloatingFilter";

export function MFilterSection() {
  const filterRef = useRef(null);
  const filterOnScreen = useOnScreen(filterRef);

  return (
    <>
      <Box ref={filterRef} bgcolor="#af9b65" px={1.5}>
        <MobileFilter />
      </Box>

      <FloatingFilter filterOnScreen={filterOnScreen} />
    </>
  );
}
